import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import QRCode from "react-qr-code";
import { onGetUser } from "../../src/utils/queries";
import { useAuthProvider } from "../../context/AuthProvider";
import { QRCodeCanvas } from "qrcode.react";


const QrModal = ({ show, setShow }) => {
  const handleClickOpen = () => {
    setShow(true);
  };


  const StackText = ({ main, secondary }) => {
    return (
      <>
        <Typography variant="big" fontWeight={600} component="p">
          {main && main}
        </Typography>
        {secondary ? <Typography variant="small">{secondary}</Typography> : null}
      </>
    );
  };


  const handleClose = () => {
    setShow(false);
  };

  const { user, first_name, last_name } = useAuthProvider()

  const { data, isSuccess, isError, isLoading } = onGetUser();
  const [value, setValue] = useState();
  useEffect(() => {
    if (isSuccess) {
      setValue(data?.data?.data?.user?.donee?.donee_code);
    }
    if (isError) {
      console.log("error");
    }
  }, [isSuccess, isError, data]);

  return (
    <Dialog
      open={show}
      fullWidth
      maxWidth={"sm"}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        zIndex: "10005",
        "& .MuiDialog-paper": {
          px: "1.2em",
          py: "1em",
          borderRadius: "8px",
          minHeight: "27rem",
        },
      }}
    >
      <DialogTitle
        id="alert-dialog-title"
        sx={{
          fontSize: "18px",
          fontWeight: 500,
          color: "grey.dark",
          marginBottom: "1em",
          justifyContent: "space-between",
          display: "flex",
          "& svg": {
            padding: "0",
          },
        }}
      >
        <Typography
          variant="h4"
          component={"h4"}
          fontWeight={500}
          lineHeight={"24px"}
          display="flex"
          justifyContent={"center"}
          alignItems={"center"}
          sx={{ displayPrint: 'none' }}
        >
          Get QR Code
        </Typography>

        <IconButton
          aria-label="close"
          size="large"
          sx={{ fontSize: "1.4rem", displayPrint: 'none' }}
          onClick={handleClose}
        >
          <ClearRoundedIcon fontSize="inherit" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: "2em" }}>
        <Grid sx={{ displayPrint: "none" }} container display={"flex"} justifyContent="space-between">
          <Grid
            item
            sm={12}
            md={5}
            lg={5}
            display={"flex"}
            justifyContent="center"
            flexDirection={"column"}
            alignItems="center"
          >

            <Box sx={{ displayPrint: "none" }}>
              {value && (
                <div style={{ position: "relative", width: 150, height: 150 }}>
                  <QRCode value={String(value)} size={150} level="H" 
                  includemargin="true"
                   />

                  <img
                    src="/assets/img/brand-icons/logomark.svg"
                    alt="Logo"
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: 30,
                      height: 30,
                      transform: "translate(-50%, -50%)",
                      background: "white",
                      padding: 4,
                      borderRadius: 6,
                    }}
                  />
                </div>
              )}

            </Box>
            <Box
              display={"flex"}
              alignItems="center"
              sx={{
                cursor: "pointer", marginTop: "0.5em",
              }}
              onClick={() => {
                navigator.clipboard.writeText(user?.donee_code || "");
                toast.success("ID copied successfully!!", {
                  position: "bottom-center",
                });
              }}
            >
              <Typography fontSize={"16px"} fontWeight={600}>
                {user?.donee_code}
              </Typography>
              <i
                className="las la-copy la-lg"
                style={{ color: "#2962FF" }}
              ></i>
            </Box>
          </Grid>
          <Grid item sm={12} md={6} lg={6} displayPrint='none'>
            <Typography variant="big">
              Here is your unique identification number and QR code.
              <br />
              <br />
              Identification number{" "}
              <span style={{ fontWeight: 600 }}>{value}</span>
              <br />
            </Typography>
            <Button
              onClick={() => window.print()}
              sx={{
                borderRadius: "8px",
                paddingY: "8px",
                paddingX: "12px",
                fontSize: "14px",
                fontWeight: "600",
                textTransform: "none",
                displayPrint: 'none',
                "&.Mui-disabled": {
                  opacity: "0.3",
                  backgroundColor: "primary.main",
                  color: "white",
                },
                marginLeft: "-1em",
                marginTop: "0.5em",
              }}
              color={"primary"}
              disableElevation
              disableFocusRipple
              disableRipple
            >
              Print QR Code
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ display: "none", displayPrint: "block" }}>
          <Box
            sx={{
              display: "none",
              displayPrint: "flex",
              justifyContent: "center",
              mb: "1em",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img
              src="/iDonatio.png"
              style={{ width: "6em", marginBottom: "0.5rem" }}
            />
            <Typography variant="small" textAlign={"center"}>
              To donate to {user?.type == "organization" ? user?.preferred_name : first_name + " " + last_name} please scan
              this QR code <br /> or input the id below
            </Typography>
          </Box>
          <Box
            sx={{
              display: "none",
              displayPrint: "flex",
              justifyContent: "flex-start",
              mt: "1em",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {user?.donee_code && (
              <QRCodeCanvas
                value={String(user.donee_code)}
                size={150}
                level="H"
                imageSettings={{
                  src: "/assets/img/brand-icons/logomark.svg",
                  height: 30,
                  width: 30,
                  excavate: true,
                }}
              />
            )}
          </Box>
          <Box
            sx={{
              display: "none",
              displayPrint: "flex",
              justifyContent: "center",
              mt: "1em",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="big"
              fontSize={"20px"}
              fontWeight={500}
              textAlign={"center"}
            >
              {value}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          sx={{
            borderRadius: "8px",
            paddingY: "8px",
            paddingX: "12px",
            fontSize: "14px",
            fontWeight: "600",
            textTransform: "none",
            displayPrint: 'none',
            "&.Mui-disabled": {
              opacity: "0.3",
              backgroundColor: "primary.main",
              color: "white",
            },
          }}
          variant="contained"
          color="primary"
          disableElevation
          disableFocusRipple
          disableRipple
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QrModal;
